import { callApi, apis } from "../api";
import { action, observable } from "mobx";
import { message } from "antd";

export class AuthStore {
  @observable code: any = "";
  @observable coupons: any = [];
  @observable errorCode: any = 200;

  @action.bound
  async submitQuestion(params: any) {
    try {
      const { method, url } = apis.question;
      const result = await callApi(method, url, params);
      // this.getCode();
      return result;
    } catch (error) {
      this.errorCode = error && error.code ? error.code : 503;
    }
  }

  @action.bound
  async setErrorCode(params: any) {
    try {
      this.errorCode = 200;
    } catch (error) {
      this.errorCode = 200;
    }
  }

  @action.bound
  async getCode() {
    try {
      const { method, url } = apis.getCode;
      const result: any = await callApi(method, url);
      this.code = result.data || "Error";
      return result;
    } catch (error) {
      this.errorCode = error && error.code ? error.code : 503;
    }
  }

  @action.bound
  async getCouponList() {
    try {
      const { method, url } = apis.coupons;
      const result: any = await callApi(method, url);
      this.coupons = result.data || "Error";
      return result;
    } catch (error) {
      this.errorCode = error && error.code ? error.code : 503;
    }
  }
  @action.bound
  async login(params: any) {
    try {
      this.errorCode = 200;

      const { method, url } = apis.login;
      const result: any = await callApi(method, url, params);
      // this.coupons = result.data || "Error";
      return true;
    } catch (error) {
      console.log("error", error);
      this.errorCode = error && error.code ? error.code : 503;

      return false;
    }
  }

  @action.bound
  async register(params: any) {
    try {
      this.errorCode = 200;
      const { method, url } = apis.register;
      const result: any = await callApi(method, url, params);
      console.log("result ", result);
      message.info("Email sent, please verify your account");
      return result;
    } catch (error) {
      this.errorCode = error && error.code ? error.code : 503;
      return false;
    }
  }

  @action.bound
  async verify(params: any) {
    try {
      const { method, url } = apis.verify;
      const result: any = await callApi(method, url, params);
      this.coupons = result.data || "Error";
      return result;
    } catch (error) {
      this.errorCode = error && error.code ? error.code : 503;
    }
  }

  @action.bound
  async submitScore(params: any) {
    try {
      const { method, url } = apis.submitScore;
      const result: any = await callApi(method, url, params);
      this.coupons = result.data || "Error";
      return result;
    } catch (error) {
      this.errorCode = error && error.code ? error.code : 503;
    }
  }
}

export const STORE_AUTH = "authStore";
